import { css } from "@emotion/react";

export const mainContainer = css`
`
